import { Box, Select, TextField } from 'vopay';
import { FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'UI';

type AccountBillingSearchParams = {
  type: string;
  currency: string;
  searchTerm: string;
};

type SearchFormProps = {
  type: string;
  currency: string;
  searchTerm: string;
  accountListingType: 'Operational' | 'Billing';
  search: (searchParams: AccountBillingSearchParams) => void;
};

type FC = FunctionComponent<SearchFormProps>;

const BankSearchForm: FC = ({ type, currency, searchTerm, accountListingType, search }: SearchFormProps) => {
  const { t } = useTranslation('translations', { keyPrefix: 'Accounts.MyBankAccounts.BankSearchForm' });
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });

  const [currentType, setCurrentType] = useState<string>(type);
  const [currentCurrency, setCurrentCurrency] = useState<string>(currency);
  const [currentSearchTerm, setCurrentSearchTerm] = useState<string>(searchTerm);

  const typeOptions = [
    { value: 'All', label: t('TypeOptions.all') },
    { value: 'BankAccount', label: t('TypeOptions.bankAccount') },
    { value: 'CreditCard', label: t('TypeOptions.creditCard') },
    { value: 'Interac', label: t('TypeOptions.interac') },
  ];

  const typeOptionsBilling = [
    { value: 'All', label: t('TypeOptions.all') },
    { value: 'BankAccount', label: t('TypeOptions.bankAccount') },
    { value: 'CreditCard', label: t('TypeOptions.creditCard') },
  ];

  const currencyOptions = [
    { value: 'All', label: t('CurrencyOptions.all') },
    { value: 'CAD', label: 'CAD' },
    { value: 'USD', label: 'USD' },
  ];
  return (
    <Box flx="row" gap="sm" wrap="wrap">
      <Box width="200px">
        <Select
          version="2"
          placeholder={t('Placeholders.type')}
          options={accountListingType === 'Operational' ? typeOptions : typeOptionsBilling}
          name="type"
          value={currentType}
          onBlur={() => {}}
          onChange={(e) => {
            setCurrentType(e.target.value);
          }}
        />
      </Box>
      <Box width="150px">
        <Select
          version="2"
          placeholder={t('Placeholders.currency')}
          options={currencyOptions}
          name="currency"
          value={currentCurrency}
          onBlur={() => {}}
          onChange={(e) => {
            setCurrentCurrency(e.target.value);
          }}
        />
      </Box>
      <Box>
        <TextField
          key="AccountSearchKeyword"
          name="AccountSearchKeyword"
          placeholder={t('Placeholders.keyword')}
          value={currentSearchTerm}
          onBlur={() => {}}
          onChange={(e) => {
            setCurrentSearchTerm(e.target.value);
          }}
          variant="outlineShadow"
        />
      </Box>
      <Button
        id="search-bankAccount"
        size="small"
        colorScheme="primary"
        onClick={() => {
          search({
            type: currentType,
            currency: currentCurrency,
            searchTerm: currentSearchTerm,
          });
        }}
      >
        {tGlobal('Buttons.search')}
      </Button>
    </Box>
  );
};

export default BankSearchForm;
